import { EditLimitationModel } from 'containers/Limitations/EditLimitationModel';
import {
  AdRequestSourceManager,
  DefaultAdRequestSourceManager,
} from 'core/adRequestSource/AdRequestSourceManager';
import { useCallAPI } from 'hooks/useCallAPI';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './momoBrandSearchKeywordsComponent.module.scss';
import i18n from 'i18n';
import { SelectOptions } from 'components/commonType';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { RtbCampaignBasicFormModel } from 'containers/RtbCampaigns/RtbCampaignSetupFlow/RtbCampaignForm/RtbCampaignBasicFormModel';
import { DefaultBrandManager } from 'core/brand/BrandManager';
import { FormikSelect } from 'components/form/field/SelectField';

const defaultBrandManager = new DefaultBrandManager();

export type SearchKeywordsComponentProps = {
  model: RtbCampaignBasicFormModel;
  limitationModel: EditLimitationModel;
  adRequestSourceManager?: AdRequestSourceManager;
};

const defaultAdRequestSourceManager = new DefaultAdRequestSourceManager();

export const BrandSearchKeywordsComponent: React.FC<
  SearchKeywordsComponentProps
> = ({
  model,
  limitationModel,
  adRequestSourceManager = defaultAdRequestSourceManager,
}) => {
  const [brandOptions, setBrandOptions] = useState<SelectOptions[]>([]);
  const { callAPIs, loading } = useCallAPI();

  const fetchBrandOptions = useCallback(async () => {
    try {
      await callAPIs(
        [defaultBrandManager.getBrandOptions.bind(defaultBrandManager)],
        (brandOptions) => {
          setBrandOptions(brandOptions);
        },
      );
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
  }, [callAPIs]);

  const getBrandLabel = useCallback(
    (brandNo: string) => {
      return (
        brandOptions.find((option) => option.value === brandNo)?.label ?? ''
      );
    },
    [brandOptions],
  );

  useEffect(() => {
    fetchBrandOptions();
  }, [fetchBrandOptions]);

  useEffect(() => {
    if (
      model.actionType === 'edit' &&
      model.formikValue.webBrandNo &&
      brandOptions.length > 0
    ) {
      model.formikValue.brandLabel =
        getBrandLabel(model.formikValue.webBrandNo) ?? '';
    }
  }, [model.actionType, model.formikValue, brandOptions, getBrandLabel]);

  const onChangeBrand = useCallback(
    (e) => {
      model.formikValue.brandLabel = getBrandLabel(e);
    },
    [getBrandLabel, model.formikValue],
  );
  const hasBind = model.flowModel?.creatives?.some(
    (item) => item.creativeType === 14,
  );
  return (
    <fieldset>
      {loading && <LoadingIndicator />}
      <legend>
        <span>{i18n.t<string>('limitation.labels.selectBrandTitle')}</span>
      </legend>
      <div className={styles.keywordSettingContainer}>
        <div className={styles.inputArea}>
          <div className={styles.descript}>
            {i18n.t<string>('limitation.labels.selectBrandDes')}
          </div>
          <div className={styles.row}>
            <FormikSelect
              name='webBrandNo'
              options={brandOptions}
              onChange={onChangeBrand}
              simpleValue={true}
              disabled={hasBind}
            />
          </div>
          <span className={styles.initHint}>
            {i18n.t<string>('limitation.hints.selectBrand')}
          </span>
        </div>
      </div>
    </fieldset>
  );
};
